import ReactGA from 'react-ga';
import { z } from 'zod';

export const PUBLIC_GOOGLE_ANALYTICS_ID = z
  .string()
  .parse(process.env.PUBLIC_GOOGLE_ANALYTICS_ID);

export const PUBLIC_GOOGLE_OPTIMIZE_KEY = z
  .string()
  .parse(process.env.PUBLIC_GOOGLE_OPTIMIZE_KEY);

function getGaInstance() {
  ReactGA.initialize(PUBLIC_GOOGLE_ANALYTICS_ID, {
    testMode: process.env.NODE_ENV === 'test',
  });

  return ReactGA;
}

export function ga(...args: unknown[]) {
  getGaInstance().ga(...args);
}

export function pushDataLayer(...data: unknown[]) {
  window.dataLayer.push(...data);
}
